import {useMediaQuery} from 'src/useMediaQuery';

export const MOBILE_MEDIA_QUERY = '(max-width: 40rem)';

type Options = {
  defaultValue?: boolean;
};

export const useIsMobile = (options: Options = {defaultValue: true}) =>
  useMediaQuery(MOBILE_MEDIA_QUERY, options);
